import React from 'react';
import { Grid, Typography, Box, FormControlLabel, Checkbox, Alert } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const InstructionsSection = ({ formData, handleChange, errors }) => {
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 3: Pre-Surgery Instructions
      </Typography>

      <Alert icon={<InfoIcon fontSize="inherit" />} severity="info" sx={{ mb: 3, borderLeft: '5px solid #01579b' }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          • No food or drink for 6-12 hours before the operation.
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
          • Residents with chronic conditions (diabetes, hypertension) need medication adjustments.
        </Typography>
      </Alert>
      
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ p: 2, border: errors.fasting_acknowledgment ? '1px solid #008080' : '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#fff' }}>
            <FormControlLabel
                control={<Checkbox checked={formData.fasting_acknowledgment} onChange={handleChange} name="fasting_acknowledgment" color="primary" />}
                label={<span>I acknowledge the fasting requirement before surgery. <span style={{ color: '#008080' }}>*</span></span>}
            />
            {errors.fasting_acknowledgment && <Typography variant="caption" color="error" display="block">This acknowledgement is required</Typography>}
          </Box>
        </Grid>
        
        <Grid item xs={12}>
          <Box sx={{ p: 2, border: errors.medication_adjustment_acknowledgment ? '1px solid #008080' : '1px solid #e0e0e0', borderRadius: 2, bgcolor: '#fff' }}>
            <FormControlLabel
                control={<Checkbox checked={formData.medication_adjustment_acknowledgment} onChange={handleChange} name="medication_adjustment_acknowledgment" color="primary" />}
                label={<span>I acknowledge that medication adjustments may be required for chronic conditions. <span style={{ color: '#008080' }}>*</span></span>}
            />
            {errors.medication_adjustment_acknowledgment && <Typography variant="caption" color="error" display="block">This acknowledgement is required</Typography>}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InstructionsSection;
